import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import LoadingScreen from "../components/LoadingScreen";

export default function ProtectedRouteGuest({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LoadingScreen label="กำลังตรวจสอบสิทธิ์…" />;
  if (user) {
    const to = location.state?.from?.pathname || "/";
    return <Navigate to={to} replace />;
  }
  return children;
}

